import { render, staticRenderFns } from "./SynergridModifyRefRequestForm.vue?vue&type=template&id=d5fa740a"
import script from "./SynergridModifyRefRequestForm.vue?vue&type=script&lang=ts"
export * from "./SynergridModifyRefRequestForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports